import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  quarterly_performance: [],
  performance_summary: [],

  loadingChain: true,
  chainData: [],
  availableChains: [],
  tokenChainBeakdown: [],
  chainTotalAmounts: [],

  loadingAsset: true,
  availableExchangeProviders: [],
  balanceBreakdown: [],
  exchangeAssetBreakdown: [],
  exchangeSplit: [],
  futureAssets: [],
  assetBreakdown: [],
  spotAssets: [],
};

export const getQuarterlyPerformance = createAsyncThunk(
  'userDashboard/data/getQuarterlyPerformance',
  async (data, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Home.Overview.quarterlyPerformance();
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

/**
 * Fetches and handles all the chain overviews
 */
export const getHomePerformanceSummary = createAsyncThunk(
  'userDashboard/data/getPerformanceSummary',
  async (wallet_address, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Home.Overview.performanceSummary();
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getDefiChainData = createAsyncThunk(
  'userDashboard/data/getDefiChainData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await Agent.Defi.Overview.chain();
      return response.data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const getExchangeAssetData = createAsyncThunk(
  'userDashboard/data/getExchangeAssetData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await Agent.Exchange.Overview.assetInfo();
      return response.data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const homeOverviewSlice = createSlice({
  name: 'home/overview',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit

    // Quarterly performance
    [getQuarterlyPerformance.pending]: (state) => {
      state.loading = true;
    },

    [getQuarterlyPerformance.fulfilled]: (state, action) => {
      state.loading = false;
      state.quarterly_performance = action?.payload?.data?.quarterly_performance || [];
    },

    [getQuarterlyPerformance.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    // Performance Summary
    [getHomePerformanceSummary.pending]: (state) => {
      state.loading = true;
    },

    [getHomePerformanceSummary.fulfilled]: (state, action) => {
      state.performance_summary = action?.payload?.data?.performance_summary || {};
    },

    [getHomePerformanceSummary.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },

    // Defi chain data
    [getDefiChainData.fulfilled]: (state, action) => {
      state.chainData = action.payload.chain_asset_breakdown;
      state.availableChains = action.payload.available_chains;
      state.tokenChainBeakdown = action.payload.token_chain_breakdown;
      state.chainTotalAmounts = action.payload.chain_total_amounts;
      state.loadingChain = false;
    },
    [getDefiChainData.pending]: (state) => {
      state.loadingChain = true;
    },
    [getDefiChainData.rejected]: (state, action) => {
      state.loadingChain = false;
      state.errors = action?.payload?.errors || {};
    },

    // Exchange Assets data
    [getExchangeAssetData.fulfilled]: (state, action) => {
      state.availableExchangeProviders = action.payload.available_exchange_providers;
      state.balanceBreakdown = action.payload.balance_breakdown;
      state.exchangeAssetBreakdown = action.payload.exchange_asset_breakdown;
      state.exchangeSplit = action.payload.exchange_split;
      state.futureAssets = action.payload.future_asset_overview;
      state.assetBreakdown = action.payload.overall_asset_breakdown;
      state.spotAssets = action.payload.spot_asset_overview;
      state.loadingAsset = false;
    },
    [getExchangeAssetData.pending]: (state) => {
      state.loadingAsset = true;
    },
    [getExchangeAssetData.rejected]: (state, action) => {
      state.loadingAsset = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const homeOverviewSelector = (state) => state.homeOverview;

export const { reducer, actions } = homeOverviewSlice;
